import { render, staticRenderFns } from "./DeliverAddressDetail.vue?vue&type=template&id=447847b4&scoped=true&"
import script from "./DeliverAddressDetail.vue?vue&type=script&lang=js&"
export * from "./DeliverAddressDetail.vue?vue&type=script&lang=js&"
import style0 from "./DeliverAddressDetail.vue?vue&type=style&index=0&id=447847b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447847b4",
  null
  
)

export default component.exports